const isPremiereBrowserPath = (pathname: string) =>
  pathname === '/premiere' || pathname.startsWith('/premiere/');

export default isPremiereBrowserPath;
